module.exports = __webpack_public_path__ + "static/media/paper-bag-strip.0c9cff0e.png";